import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UtilsService } from 'projects/common/services/utils.service';
import { ScreenType } from 'projects/common/model/ScreenType';
import { EmpireStateCode } from '../wizumen-models';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { WizumenService } from 'projects/common/services/wizumen.service';

@Component({
  selector: 'wizumen-confirmed-info',
  template: `
    <div *ngIf="screenType === 'MOBILE'">
        <div *ngIf="isChanchitoOff">
          <p class="wizumen-pig-text" [ngClass]="{'-coupon': isChanchitoOff}">{{pigText}}</p>
            <div class="wizumen-title-and-image-container flex align-center justify-space-between -eva-3-pb-sm">
              <span class="wizumen-title eva-3-h4">
                {{titleText}}
              </span>
            </div>
        </div>

        <div *ngIf="!isChanchitoOff">
          <div class="wizumen-title-and-image-container flex align-center justify-space-between -eva-3-pb-sm">
              <span class="wizumen-title eva-3-h4">
                {{titleText}}
              </span>
              <img *ngIf="isStressContent"
                class="coupon-image"
                src="https://media.staticontent.com/media/pictures/664b93bd-44fc-4ae0-95ae-52d1ad2f10fc" alt="Coupon Image" loading="lazy"
              />
          </div>
          <p class="wizumen-pig-text" [ngClass]="{'-coupon': isChanchitoOff}">{{pigText}}</p>
        </div>
    </div>

    <div *ngIf="screenType !== 'MOBILE' && amountOfItems === 1" class="v2-pig-and-text-container">
        <div *ngIf="isChanchitoOff">
          <div class="wizumen-title-and-image-container align-center justify-space-between">
            <div>
              <p class="wizumen-pig-text" [ngClass]="{'-coupon': isChanchitoOff}">{{pigText}}</p>
              <span class="wizumen-title eva-3-h4">
                {{titleText}}
              </span>
            </div>
          </div>
        </div>

        <div *ngIf="!isChanchitoOff">
          <div class="wizumen-title-and-image-container flex align-center">
              <span class="wizumen-title eva-3-h4">
                {{titleText}}
              </span>
              <img *ngIf="isStressContent"
                class="coupon-image"
                src="https://media.staticontent.com/media/pictures/664b93bd-44fc-4ae0-95ae-52d1ad2f10fc" alt="Coupon Image" loading="lazy"
              />
          </div>
          <p class="wizumen-pig-text" [ngClass]="{'-coupon': isChanchitoOff}">{{pigText}}</p>
        </div>
    </div>

    <div *ngIf="screenType !== 'MOBILE' && amountOfItems !== 1">
        <div *ngIf="isChanchitoOff" class="wizumen-items-title-container">
            <div class="wizumen-title-and-pig-container">
                <p class="wizumen-pig-text" [ngClass]="{'-coupon': isChanchitoOff}">{{pigText}}</p>
                <span class="wizumen-title eva-3-h4">
                  {{titleText}}
                </span>
            </div>
        </div>

        <div *ngIf="!isChanchitoOff" class="wizumen-items-title-container">
            <div class="wizumen-title-and-pig-container">
                <span class="wizumen-title eva-3-h4">
                  {{titleText}}
                </span>
                <p class="wizumen-pig-text" [ngClass]="{'-coupon': isChanchitoOff}">{{pigText}}</p>
            </div>
        </div>
    </div>
  `,
  styleUrls: ['../wizumen.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenConfirmedInfoComponent implements OnInit {
  @Input() amountOfItems: number;
  @Input() titleText: string;
  @Input() pigText: string;

  statusName: EmpireStateCode = EmpireStateCode.CONFIRMED;
  screenType: ScreenType;
  isChanchitoOff: boolean;
  isStressContent: boolean;

  constructor(private utilsService: UtilsService, landingModelService: LandingModelService) {

    this.isChanchitoOff = landingModelService.getLandingModel().abTests?.ab.includes("ChanchitoOff|off_true");
    this.isStressContent = landingModelService.getLandingModel().abTests?.ab.includes("S-PIG-RETURNERS|branch_test");
  }

  ngOnInit() {
    this.screenType = this.utilsService.getScreenType();
  }

}
